"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Percentaje = function Percentaje(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 16.856c-3.967 0-7.195-3.228-7.195-7.196 0-3.968 3.228-7.196 7.196-7.196 3.968 0 7.196 3.228 7.196 7.196 0 3.968-3.228 7.196-7.196 7.196zm0-13.308A6.122 6.122 0 003.89 9.66 6.122 6.122 0 0010 15.772a6.122 6.122 0 006.112-6.112A6.12 6.12 0 0010 3.548z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.196 12.876a.545.545 0 01-.452-.844l3.404-5.104a.545.545 0 01.752-.152.545.545 0 01.152.752l-3.404 5.104a.535.535 0 01-.452.244zM8.371 9.5a1.429 1.429 0 11.002-2.858A1.429 1.429 0 018.371 9.5zm0-1.768a.347.347 0 00-.344.344c0 .188.156.344.344.344a.347.347 0 00.344-.344.341.341 0 00-.344-.344zM11.447 12.844a1.429 1.429 0 11.002-2.858 1.429 1.429 0 01-.002 2.858zm0-1.772a.347.347 0 00-.343.344c0 .188.155.344.344.344a.347.347 0 00.343-.344.347.347 0 00-.344-.344z",
    fill: secondaryColor
  }));
};
var _default = exports["default"] = Percentaje;